import { Link } from 'react-router-dom';

import { environmentTypes, environmentName, APP_LOGO_PATH } from "../settings/config";

import store from '../../redux/store';
import { actions } from '../../redux/actions';

const imagesBasePath = `${process.env.PUBLIC_URL}/static/images`;

export const RenderAppLogo = () => {
    let src = imagesBasePath + '/Logo_only.png';
    if ( environmentName === environmentTypes.ACCOUNTZONTRACK ) {
        src = imagesBasePath + '/accountzontrack_logo_with_title.png';
    } else if ( environmentName === environmentTypes.SREC ) {
        src = imagesBasePath + '/srec_logo_with_title.png';
    } else if ( environmentName === environmentTypes.MUTHAYAMMAL ) {
        src = imagesBasePath + '/muthayammal_logo_with_title.png';
    } else if ( environmentName === environmentTypes.TAGOREIET ) {
        src = imagesBasePath + '/tagoreiet_logo.gif';
    } else if ( environmentName === environmentTypes.YI ) {
        src = imagesBasePath + '/yi_logo_with_title.png';
    }

    return (
        <div className='d-flex align-items-center justify-content-center pt-5 logo-img logo' style={{ width: "50%" }}>
            <img src={src} alt="logo"/>
        </div>
    )
};

export const RenderHeaderAppLogo = ({ isSidebarOpen }) => {
    let src = imagesBasePath + '/Logo_only.png';
    if ( environmentName === environmentTypes.ACCOUNTZONTRACK ) {
        src = imagesBasePath + '/accountzontrack_logo_with_title.png';
    } else if ( environmentName === environmentTypes.SREC ) {
        src = imagesBasePath + '/srec_logo_with_title.png';
    } else if ( environmentName === environmentTypes.MUTHAYAMMAL ) {
        src = imagesBasePath + '/muthayammal_logo_with_title.png';
    } else if ( environmentName === environmentTypes.TAGOREIET ) {
        src = imagesBasePath + '/tagoreiet_logo.gif';
    } else if ( environmentName === environmentTypes.YI ) {
        src = imagesBasePath + '/yi_logo_with_title.png';
    }
    return (
        <div className='header-logo-box'>
            <Link className="d-none d-lg-flex" to="/">
                <img src={imagesBasePath + '/assessmaxplus_1.png'} alt="logo" width="60%" />
            </Link>
            <i className={`d-flex d-lg-none ${isSidebarOpen ? 'fas fa-times': 'fa fa-bars'} d-flex justify-content-center`}  onClick={() => { store.dispatch(actions.setSideBar(true)); }}></i>
        </div>
    )
};

export const RenderHeaderText = () => {
    return (
        <div className='header-text'>
            <div className='text-primary text-2l' style={{ textAlign: 'center', fontWeight: 'bold' }}>
                <img src={imagesBasePath + '/assessmaxplus.png'} alt="logo" width="15%" />
                {/* <Link to="/">AssessMax<span className='text-secondary'>Plus</span></Link> */}
            </div>
        </div>
    );
};

export const RenderNoAuthHeaderText = () => {
    return (
        <div className='heading'>
            <img src={imagesBasePath + '/assessmaxplus.png'} alt="logo" width="30%" />
            <span className='px-2'>👋</span>
        </div>
    );
};

export const ProfileAvatar = () => {
    let src = imagesBasePath + '/Logo_only.png';
    if ( environmentName === environmentTypes.ACCOUNTZONTRACK ) {
        src = imagesBasePath + '/accountzontrack_logo_with_title.png';
    } else if ( environmentName === environmentTypes.SREC ) {
        src = imagesBasePath + '/srec_logo.png';
    } else if ( environmentName === environmentTypes.MUTHAYAMMAL ) {
        src = imagesBasePath + '/muthayammal_logo.png';
    } else if ( environmentName === environmentTypes.TAGOREIET ) {
        src = imagesBasePath + '/tagoreiet_logo.png';
    } else if ( environmentName === environmentTypes.YI ) {
        src = imagesBasePath + '/yi_logo.png';
    }
    return <img role='button' className='profile-avatar' src={src} alt="profile"  />;
};

export const AppLogo = ({ publicHeader=false }) => (
    
    <div className={`app-logo ${publicHeader && 'app-public'}`}>
        <img className="logo-image" src={APP_LOGO_PATH} />
        <div className="d-flex flex-column justify-content-center">
            <h1 className="logo-text" >
               <span
   style={{ color: "#0033cd !important" }}>Civil Vertex</span>
                <span className="text-secondary"> Ai</span>
                {/* <span className="text-primary-light" style={{ marginLeft: '0.125rem', fontSize: "0.75rem" }}>Plus</span> */}
            </h1>
            {/* <div className="logo-subtext">CIVIL PLATFORM</div> */}
        </div>
    </div>
);